import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, computed, ref, watch } from "vue";
import { MultiselectInputProps, SelectOption } from "@/types";
import { useMargins, useVModel } from "@/hooks";


/**
 * A generic multiselect input.
 */
const __default__ = {
  name: "MultiselectInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    options: {},
    addValues: { type: Boolean },
    clearable: { type: Boolean },
    label: { default: "" },
    optionValue: { type: [String, Function], default: undefined },
    optionLabel: { type: [String, Function], default: undefined },
    optionToValue: { type: Boolean },
    outlined: { type: Boolean },
    disabled: { type: Boolean },
    hint: { default: undefined },
    errorMessage: { type: [String, Boolean], default: "" },
    class: { default: "" },
    b: { default: "1" },
    dataCy: { default: undefined }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



const model = useVModel(props, "modelValue");

const className = useMargins(props, () => [[!!props.class, props.class]]);

const showError = computed(
  () => (props.errorMessage && props.errorMessage.length > 0) || undefined
);

const options = ref(props.options);

/**
 * Filters the artifact type options.
 * @param searchText - The search text to filter with.
 * @param update - A function call to update the options.
 */
function filter(
  searchText: string | null,
  update: (fn: () => void) => void
): void {
  update(() => {
    if (!searchText) {
      options.value = props.options;
    } else {
      const lowercaseSearchText = searchText.toLowerCase();

      options.value = props.options.filter(
        (option: string | SelectOption | unknown) => {
          const value =
            !!option && typeof option === "object" && "name" in option
              ? String(option.name)
              : String(option);

          return value.toLowerCase().includes(lowercaseSearchText);
        }
      );
    }
  });
}

watch(
  () => props.options,
  (newOptions) => (options.value = newOptions)
);

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    multiple: "",
    filled: !props.outlined,
    outlined: props.outlined,
    "use-chips": "",
    "use-input": "",
    label: props.label,
    options: options.value,
    "option-value": props.optionValue,
    "option-label": props.optionLabel,
    "map-options": props.optionToValue,
    "emit-value": props.optionToValue,
    "data-cy": props.dataCy,
    "error-message": props.errorMessage || undefined,
    error: showError.value,
    class: _normalizeClass(_unref(className)),
    hint: props.hint,
    "new-value-mode": props.addValues ? 'add-unique' : undefined,
    "input-debounce": "0",
    clearable: props.clearable,
    onFilter: filter
  }, {
    prepend: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend")
    ]),
    _: 3
  }, 8, ["modelValue", "filled", "outlined", "label", "options", "option-value", "option-label", "map-options", "emit-value", "data-cy", "error-message", "error", "class", "hint", "new-value-mode", "clearable"]))
}
}

})